import { GET_SEARCH_PRJ_FILTERS } from '@package/actions';

const initialState = {
  error: null,
  items: [],
  loaded: false,
  loading: false,
};

/**
 * querystringsearch reducer.
 * @function querystring
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export function searchProjectFilters(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_SEARCH_PRJ_FILTERS}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${GET_SEARCH_PRJ_FILTERS}_SUCCESS`:
      return {
        ...state,
        error: null,
        result: action.result,
        loaded: true,
        loading: false,
      };
    case `${GET_SEARCH_PRJ_FILTERS}_FAIL`:
      return {
        ...state,
        error: action.error,
        result: null,
        loading: false,
        loaded: false,
      };
    default:
      return state;
  }
}
